import { makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) { return ({
    root: function (style) { return ({
        fontSize: (style && style.fontSize) || '10px',
        color: (style && style.color) || "".concat(theme.palette.common.white),
        borderRight: "1px solid ".concat(theme.palette.common.white, " !important"),
    }); },
    span: function () { return ({
        lineHeight: 1,
        paddingLeft: 5,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }); },
    icon: function (style) { return ({
        minHeight: '15px',
        minWidth: '15px',
        fontSize: (style && style.fontSize) || '1.5em',
        color: (style && style.color) || "".concat(theme.palette.common.white),
    }); },
    dropDownIconButton: function (style) { return ({
        fontSize: (style && style.fontSize) || '1.5em',
        color: (style && style.color) || "".concat(theme.palette.common.white),
        minWidth: '10px',
        width: '20px',
        padding: '4px 0px',
        '& > .MuiButton-label': {
            width: '20px',
        },
    }); },
}); });
//# sourceMappingURL=style.js.map